import { render, staticRenderFns } from "./BrandOfferHeaderRegion.vue?vue&type=template&id=f93f477e&"
import script from "./BrandOfferHeaderRegion.vue?vue&type=script&lang=js&"
export * from "./BrandOfferHeaderRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports